// Author Eric
// Date 2020-09-18 09:17:42

import * as model from "@/model/sithMes/andon/SithMesAndonTaskScheduleModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesAndonTaskSchedule(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_ANDON_URL,
    })
    .buildStore()
